import React, { useState, useEffect, useMemo, useCallback } from "react"
import { Table, Col, Row } from "reactstrap"
import api from "API/Api"
import { Link } from "react-router-dom"
import SweetAlert from "react-bootstrap-sweetalert"
import loader from "./../../assets/loading/loader.gif"
import { usePermissions } from "API/PermissionContext"
import BulkImportExport from "../../components/BulkImportExport"

const ChillingCenters = () => {
  const { canAdd, canEdit, canDelete, canExport, MODULE } = usePermissions()
  const MID = MODULE.CHILLING_CENTERS
  const [centers, setCenters] = useState([])
  const [dataLoaded, setDataLoaded] = useState(false)
  const [checkedItems, setCheckedItems] = useState({})
  const [parentChecked, setParentChecked] = useState(false)
  const [confirm_alert, setconfirm_alert] = useState(false)
  const [confirm_multiple_alert, setconfirm_multiple_alert] = useState(false)
  const [success_dlg, setsuccess_dlg] = useState(false)
  const [dynamic_title, setdynamic_title] = useState("")
  const [dynamic_description, setdynamic_description] = useState("")
  const [centerId, setCenterId] = useState("")
  const [search, setSearch] = useState("")
  const [showFilter, setShowFilter] = useState(false)
  const [filterSearch, setFilterSearch] = useState({ name: "", number: "", village: "", district: "", state: "", plant: "" })

  const fetchData = useCallback(async () => {
    try {
      const resp = await api.get("centers")
      setCenters(Array.isArray(resp.data.data) ? resp.data.data : resp.data.data?.data || [])
    } catch (e) { console.error(e) }
    setDataLoaded(true)
  }, [])

  useEffect(() => { fetchData() }, [fetchData])

  const handleDelete = async () => {
    try { await api.delete("delete-center/" + centerId); fetchData() } catch (e) { console.error(e) }
  }
  const handleMultiDelete = async () => {
    const ids = Object.keys(checkedItems).filter(k => checkedItems[k])
    if (!ids.length) return
    try { await api.post("delete-multiple-chillingcenter", { items: ids }); setCheckedItems({}); setParentChecked(false); fetchData() } catch (e) { console.error(e) }
  }
  const handleCheckbox = id => {
    setCheckedItems(prev => {
      const n = { ...prev, [id]: !prev[id] }
      setParentChecked(centers.length > 0 && centers.every(c => n[c.id]))
      return n
    })
  }
  const handleParentCheckbox = () => {
    const n = !parentChecked; setParentChecked(n)
    const items = {}; centers.forEach(c => { items[c.id] = n }); setCheckedItems(items)
  }
  const selectedCount = Object.values(checkedItems).filter(Boolean).length

  const filtered = useMemo(() => {
    if (!search) return centers
    const s = search.toLowerCase()
    return centers.filter(c =>
      (c.name || "").toLowerCase().includes(s) ||
      (c.number || "").toLowerCase().includes(s) ||
      (c.companyName || "").toLowerCase().includes(s) ||
      (c.plantName || "").toLowerCase().includes(s) ||
      (c.code || c.cc_code || "").toLowerCase().includes(s)
    )
  }, [centers, search])

  const summaryCards = [
    { label: "Total Centers", value: centers.length, icon: "fa-warehouse", color: "#6366f1" },
    { label: "Plants", value: new Set(centers.map(c => c.plantName).filter(Boolean)).size, icon: "fa-industry", color: "#22c55e" },
    { label: "States", value: new Set(centers.map(c => c.stateName).filter(Boolean)).size, icon: "fa-map-marker-alt", color: "#0ea5e9" },
  ]

  const removeFilter = () => {
    setFilterSearch({ name: "", number: "", village: "", district: "", state: "", plant: "" })
    setShowFilter(!showFilter)
  }

  const uniqueStates = useMemo(() => [...new Set(centers.map(c => c.stateName).filter(Boolean))].sort(), [centers])
  const uniqueDistricts = useMemo(() => [...new Set(centers.map(c => c.districtName).filter(Boolean))].sort(), [centers])
  const uniquePlants = useMemo(() => [...new Set(centers.map(c => c.plantName).filter(Boolean))].sort(), [centers])

  // CSV Export
  const exportCSV = () => {
    if (!filtered.length) return
    const headers = ["#", "Company", "Plant", "CC Number", "CC Name", "CC Code"]
    const rows = filtered.map((c, i) => [
      i + 1, c.companyName || "", c.plantName || "", c.number, c.name, c.code || c.cc_code || ""
    ])
    const csvContent = [headers, ...rows].map(r => r.map(v => `"${(v || "").toString().replace(/"/g, '""')}"`).join(",")).join("\n")
    const blob = new Blob([csvContent], { type: "text/csv" })
    const url = URL.createObjectURL(blob)
    const a = document.createElement("a"); a.href = url; a.download = `chilling_centers_${new Date().toISOString().slice(0, 10)}.csv`
    a.click(); URL.revokeObjectURL(url)
  }

  return (
    <>
      <div className="dashBody">

        <div className="font-size-18 mb-0 dashHeader" style={{ display: "flex", justifyContent: "space-between", alignItems: "center", flexWrap: "wrap", gap: "8px" }}>
          <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
            <h4 style={{ margin: 0 }}>Chilling Centers</h4>
            {canAdd(MID) && (
              <Link to="/add-center" title="Add Center"
                style={{ width: "32px", height: "32px", borderRadius: "4px", background: "#28a745", color: "#fff",
                  display: "inline-flex", alignItems: "center", justifyContent: "center", fontSize: "14px", textDecoration: "none" }}>
                <i className="fas fa-plus"></i>
              </Link>
            )}
            {canDelete(MID) && (
              <button title={selectedCount > 0 ? `Delete ${selectedCount} selected` : "Select items to delete"}
                onClick={() => { if (selectedCount > 0) setconfirm_multiple_alert(true); else alert("Please select at least one center to delete.") }}
                style={{ width: "32px", height: "32px", borderRadius: "4px", background: "#dc3545", color: "#fff",
                  border: "none", display: "inline-flex", alignItems: "center", justifyContent: "center", fontSize: "14px", cursor: "pointer", opacity: selectedCount > 0 ? 1 : 0.7 }}>
                <i className="fas fa-trash"></i>
              </button>
            )}
            <button title="Toggle Filter" onClick={removeFilter}
              style={{ width: "32px", height: "32px", borderRadius: "4px", background: "#0d6efd", color: "#fff",
                border: "none", display: "inline-flex", alignItems: "center", justifyContent: "center", fontSize: "14px", cursor: "pointer" }}>
              <i className="fas fa-filter"></i>
            </button>
            <BulkImportExport
              data={centers}
              columns={[
                { key: "plant_id", label: "Plant ID", required: true },
                { key: "name", label: "CC Name", required: true },
                { key: "number", label: "CC Number", required: true },
                { key: "code", label: "CC Code" },
              ]}
              sampleData={[{
                plant_id: "1", name: "Sample CC", number: "CC001", code: "SC01"
              }]}
              apiEndpoint="create-center"
              entityName="Chilling_Centers"
              onImportComplete={fetchData}
              showExport={canExport(MID)}
              showImport={canAdd(MID)}
            />
          </div>
          <div style={{ display: "flex", alignItems: "center" }}>
            <input type="text" className="form-control form-control-sm" placeholder="Search"
              style={{ width: "180px", borderRadius: "4px 0 0 4px" }}
              value={search} onChange={e => setSearch(e.target.value)} />
            <button className="btn btn-primary btn-sm" style={{ borderRadius: "0 4px 4px 0", height: "31px" }}>
              <i className="fas fa-search"></i>
            </button>
          </div>
        </div>

        {/* Summary Cards */}
        <Row className="mb-3 mt-2">
          {summaryCards.map((card, i) => (
            <Col md={3} sm={6} key={i}>
              <div style={{
                background: "#fff", borderRadius: "10px", padding: "14px 16px",
                borderLeft: `4px solid ${card.color}`, boxShadow: "0 1px 3px rgba(0,0,0,0.08)",
                display: "flex", alignItems: "center", gap: "12px", marginBottom: "8px"
              }}>
                <div style={{ width: "40px", height: "40px", borderRadius: "8px", background: card.color + "15",
                  display: "flex", alignItems: "center", justifyContent: "center" }}>
                  <i className={`fas ${card.icon}`} style={{ color: card.color, fontSize: "16px" }}></i>
                </div>
                <div>
                  <div style={{ fontSize: "20px", fontWeight: "700", color: "#1e293b" }}>{card.value}</div>
                  <div style={{ fontSize: "11px", color: "#6c757d", textTransform: "uppercase", letterSpacing: "0.5px" }}>{card.label}</div>
                </div>
              </div>
            </Col>
          ))}
        </Row>

        <div className="table-responsive">
          <Table className="table mb-0 dairyTbl" id="centerTbl">
            <thead>
              <tr>
                <th><input type="checkbox" checked={parentChecked} onChange={handleParentCheckbox} /></th>
                <th>#</th>
                <th>Company</th>
                <th>Plant</th>
                <th>CC Number</th>
                <th>CC Name</th>
                <th>CC Code</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              {showFilter && (
                <tr>
                  <td></td><td></td>
                  <td>
                    <select className="form-control form-control-sm" value={filterSearch.company || ""}
                      onChange={e => setFilterSearch(s => ({ ...s, company: e.target.value }))}>
                      <option value="">All</option>
                      {[...new Set(centers.map(c => c.companyName).filter(Boolean))].sort().map((c, i) => <option key={i} value={c}>{c}</option>)}
                    </select>
                  </td>
                  <td>
                    <select className="form-control form-control-sm" value={filterSearch.plant}
                      onChange={e => setFilterSearch(s => ({ ...s, plant: e.target.value }))}>
                      <option value="">All</option>
                      {uniquePlants.map((p, i) => <option key={i} value={p}>{p}</option>)}
                    </select>
                  </td>
                  <td><input type="text" className="form-control form-control-sm" placeholder="Number..."
                    value={filterSearch.number} onChange={e => setFilterSearch(s => ({ ...s, number: e.target.value }))} /></td>
                  <td><input type="text" className="form-control form-control-sm" placeholder="Name..."
                    value={filterSearch.name} onChange={e => setFilterSearch(s => ({ ...s, name: e.target.value }))} /></td>
                  <td></td>
                  <td></td>
                </tr>
              )}
              {!dataLoaded ? (
                <tr><td colSpan={8}><img className="loaderImg" src={loader} alt="Loading" /></td></tr>
              ) : filtered.length > 0 ? (
                filtered.map((center, i) => (
                  <tr key={center.id}>
                    <td><input type="checkbox" checked={!!checkedItems[center.id]} onChange={() => handleCheckbox(center.id)} /></td>
                    <td>{i + 1}</td>
                    <td><span style={{ background: '#22c55e15', color: '#22c55e', padding: '2px 8px', borderRadius: '4px', fontSize: '11px', fontWeight: 600 }}>{center.companyName || 'Unassigned'}</span></td>
                    <td><span style={{ background: '#6366f115', color: '#6366f1', padding: '2px 8px', borderRadius: '4px', fontSize: '11px', fontWeight: 600 }}>{center.plantName || 'Unassigned'}</span></td>
                    <td>{center.number}</td>
                    <td style={{ fontWeight: "600" }}>{center.name}</td>
                    <td>{center.code || center.cc_code || "-"}</td>
                    <td>
                      <div style={{ display: "flex", gap: "4px" }}>
                        <Link title="Mobile Settings" to={"/cc-mobile-settings/" + center.id}
                          style={{ width: "28px", height: "28px", borderRadius: "4px", background: "#6f42c1", color: "#fff",
                            display: "inline-flex", alignItems: "center", justifyContent: "center", fontSize: "12px" }}>
                          <i className="fas fa-cog"></i></Link>
                        <Link title="Device Status" to={"/cc-mobile-login/" + center.id}
                          style={{ width: "28px", height: "28px", borderRadius: "4px", background: "#17a2b8", color: "#fff",
                            display: "inline-flex", alignItems: "center", justifyContent: "center", fontSize: "12px" }}>
                          <i className="fas fa-mobile-alt"></i></Link>
                        {canEdit(MID) && <Link title="Edit" to={"/edit-center/" + center.id}
                          style={{ width: "28px", height: "28px", borderRadius: "4px", background: "#0d6efd", color: "#fff",
                            display: "inline-flex", alignItems: "center", justifyContent: "center", fontSize: "12px" }}>
                          <i className="fas fa-edit"></i></Link>}
                      </div>
                    </td>
                  </tr>
                ))
              ) : (
                <tr><td colSpan={8} className="text-center py-4">
                  <i className="fas fa-warehouse fa-2x text-muted mb-2 d-block"></i>No chilling centers found
                </td></tr>
              )}
            </tbody>
          </Table>
        </div>
      </div>

      {confirm_alert && (
        <SweetAlert title="Are you sure?" warning showCancel confirmBtnBsStyle="success" cancelBtnBsStyle="danger"
          onConfirm={() => { handleDelete(); setconfirm_alert(false); setsuccess_dlg(true); setdynamic_title("Deleted"); setdynamic_description("Center deleted.") }}
          onCancel={() => setconfirm_alert(false)}>You won't be able to revert this!</SweetAlert>
      )}
      {confirm_multiple_alert && (
        <SweetAlert title={`Delete ${selectedCount} centers?`} warning showCancel confirmBtnBsStyle="success" cancelBtnBsStyle="danger"
          onConfirm={() => { handleMultiDelete(); setconfirm_multiple_alert(false); setsuccess_dlg(true); setdynamic_title("Deleted"); setdynamic_description("Centers deleted.") }}
          onCancel={() => setconfirm_multiple_alert(false)}>You won't be able to revert this!</SweetAlert>
      )}
      {success_dlg && (
        <SweetAlert success title={dynamic_title} onConfirm={() => setsuccess_dlg(false)}>{dynamic_description}</SweetAlert>
      )}
    </>
  )
}

export default ChillingCenters
